var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessful(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 265.75,
    height: 265.75,
    viewBox: "0 0 265.75 265.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "successful",
    transform: "translate(1.125 1.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M142.636,24.118,131.773,12.947a2.335,2.335,0,0,0-1.728-.741h0a2.241,2.241,0,0,0-1.728.741L53.02,88.8l-27.4-27.4a2.386,2.386,0,0,0-3.456,0L11.175,72.382a2.459,2.459,0,0,0,0,3.518l34.563,34.562a10.931,10.931,0,0,0,7.221,3.518c3.271,0,6.11-2.407,7.159-3.395h.062L142.7,27.636A2.639,2.639,0,0,0,142.636,24.118Z",
    transform: "translate(54.906 68.687)",
    fill: "#5ade53",
    stroke: "#fff",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M131.75,20.656a111.112,111.112,0,0,1,78.568,189.662A111.112,111.112,0,0,1,53.182,53.182,110.359,110.359,0,0,1,131.75,20.656m0-17.281A128.375,128.375,0,1,0,260.125,131.75,128.355,128.355,0,0,0,131.75,3.375Z",
    fill: "#5ade53",
    stroke: "#fff",
    strokeWidth: 9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessful);
export default __webpack_public_path__ + "static/media/successful.dcd7f1858289b02d5f757022d7b656ca.svg";
export { ForwardRef as ReactComponent };